const Menu = () => {
	return <>
	<h3 className="text-center mt-4">Eva's times tables - beat the clock</h3>
	<div className="d-flex justify-content-center align-items-center">
		<div className="list-group" style={{width: '250px', textAlign:'center', fontSize:'20px', marginTop:'30px'}}>
			<a href="../" className="list-group-item list-group-item-action">Back to Eva's Maths</a>
			<a href="?page=exercise&exercise=2to5" className="list-group-item list-group-item-action">2 to 5</a>
			<a href="?page=exercise&exercise=6to9" className="list-group-item list-group-item-action">6 to 9</a>
			<a href="?page=exercise&exercise=2to9" className="list-group-item list-group-item-action">2 to 9</a>
			<a href="?page=exercise&exercise=6to12" className="list-group-item list-group-item-action">6 to 12</a>
			<a href="?page=exercise&exercise=2to12" className="list-group-item list-group-item-action">2 to 12</a>
			<a href="?page=myResults" className="list-group-item list-group-item-action">My Results</a>
		</div>
	</div>
	</>;
};

export default Menu;